import { render, staticRenderFns } from "./WkResourceExportsHistoryItems.vue?vue&type=template&id=15f8f177"
import script from "./WkResourceExportsHistoryItems.vue?vue&type=script&lang=ts"
export * from "./WkResourceExportsHistoryItems.vue?vue&type=script&lang=ts"
import style0 from "./WkResourceExportsHistoryItems.vue?vue&type=style&index=0&id=15f8f177&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports